import { useMemo } from 'react';
import { RRule, Weekday } from 'rrule';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { i18n } from '@shared/util/i18n';
import { matchesWeekday } from '../RRuleHelpers';
import { SelectableDay } from './SelectableDay';

interface Props {
  rruleString: string | undefined;
  onChange(rule: Weekday | undefined): void;
}

export function SelectableDays({ rruleString, onChange }: Props) {
  const rule = useMemo(
    () => (!!rruleString ? RRule.fromString(rruleString) : undefined),
    [rruleString],
  );
  return (
    <>
      <View paddingHorizontal={3} paddingTop={3}>
        <Text size="body2" weight="semibold">
          {i18n('card.blocks.recurrenceInput.on')}
        </Text>
      </View>

      <View row paddingHorizontal={3} paddingVertical={2}>
        <View paddingRight={0.5}>
          <SelectableDay
            isSelected={matchesWeekday(rule, RRule.SU)}
            day={i18n('common.datetime.abbrevations.sunday')}
            onSelect={() => onChange(RRule.SU)}
          />
        </View>

        <View paddingHorizontal={0.5}>
          <SelectableDay
            isSelected={matchesWeekday(rule, RRule.MO)}
            day={i18n('common.datetime.abbrevations.monday')}
            onSelect={() => onChange(RRule.MO)}
          />
        </View>

        <View paddingHorizontal={0.5}>
          <SelectableDay
            isSelected={matchesWeekday(rule, RRule.TU)}
            day={i18n('common.datetime.abbrevations.tuesday')}
            onSelect={() => onChange(RRule.TU)}
          />
        </View>

        <View paddingHorizontal={0.5}>
          <SelectableDay
            isSelected={matchesWeekday(rule, RRule.WE)}
            day={i18n('common.datetime.abbrevations.wednesday')}
            onSelect={() => onChange(RRule.WE)}
          />
        </View>

        <View paddingHorizontal={0.5}>
          <SelectableDay
            isSelected={matchesWeekday(rule, RRule.TH)}
            day={i18n('common.datetime.abbrevations.thursday')}
            onSelect={() => onChange(RRule.TH)}
          />
        </View>

        <View paddingHorizontal={0.5}>
          <SelectableDay
            isSelected={matchesWeekday(rule, RRule.FR)}
            day={i18n('common.datetime.abbrevations.friday')}
            onSelect={() => onChange(RRule.FR)}
          />
        </View>

        <View paddingLeft={0.5}>
          <SelectableDay
            isSelected={matchesWeekday(rule, RRule.SA)}
            day={i18n('common.datetime.abbrevations.saturday')}
            onSelect={() => onChange(RRule.SA)}
          />
        </View>
      </View>
    </>
  );
}
